import { Directive, inject, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthService } from '@core/services/auth.service';
import { environment } from '@environments/environment';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[hasPermission]',
  standalone: true
})
export class HasPermissionDirective implements OnInit, OnDestroy {
  private viewContainer = inject(ViewContainerRef);
  private templateRef = inject(TemplateRef);
  private authService = inject(AuthService);

  private requiredPermissions: string[] = [];
  private subscription: Subscription | null = null;

  @Input()
  set hasPermission(permissions: string | string[]) {
    this.requiredPermissions = Array.isArray(permissions) ? permissions : [permissions];
    this.updateView();
  }

  ngOnInit() {
    this.subscription = this.authService.getPermissions().subscribe(perms => {
      this.updateView(perms);
    });
  }

  private updateView(perms?: string[] | null) {
    this.viewContainer.clear();

    if ((environment as any).local && !this.authService.getIdToken()) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      return;
    }

    const currentPerms = perms ?? this.authService.getPermissionsValue();
    if (
      currentPerms &&
      this.requiredPermissions.length > 0 &&
      this.requiredPermissions.some(p => currentPerms.includes(p))
    ) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
